module.exports = __webpack_public_path__ + "static/media/page9_mum_kids01.77aa8fb7.png";